import service from "@irati/utils/tracking"

import ModalLocation from "./enums/ModalLocation"

class PerksGOTrackingEvents {
  showFindOutMoreModal(modalLocation: ModalLocation) {
    const data = {
      modal_location: modalLocation
    }
    service.trackPerksEvent("perksgo_find_out_more", data)
  }

  showLinkCardModal(modalLocation: ModalLocation) {
    const data = {
      modal_location: modalLocation
    }
    service.trackPerksEvent("perksgo_add_card_details", data)
  }

  cardSuccessfullyLinked(cardCount: number) {
    const data = {
      card_number: cardCount
    }
    service.trackPerksEvent("perksgo_link_card", data)
  }

  goToWalletCTA() {
    service.trackPerksEvent("perksgo_go_wallet_cta")
  }

  manageLinkedCardsCTA() {
    service.trackPerksEvent("perksgo_manage_linked_cards_cta")
  }

  clickMyLinkedCards() {
    service.trackPerksEvent("perksgo_click_my_linked_cards")
  }

  clickLinkNewCard() {
    service.trackPerksEvent("perksgo_click_link_new_card")
  }

  clickDeleteLinkedCard() {
    service.trackPerksEvent("perksgo_click_delete_linked_card")
  }

  confirmDeleteLinkedCard(cardCount: number) {
    const data = {
      card_number: cardCount
    }
    service.trackPerksEvent("perksgo_confirm_delete_linked_card", data)
  }

  cancelDeleteLinkedCard() {
    service.trackPerksEvent("perksgo_cancel_delete_linked_card")
  }
}

export default new PerksGOTrackingEvents()
